import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const SkipIcon = ({
  color = colors.black,
  className,
}: Pick<IProps, 'color' | 'className'>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ marginLeft: '-2px' }}
    >
      <path
        d="M10.2285 10.4565L5.77211 6.00013"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M5.77148 10.4565L10.2279 6.00014"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M12.2426 3.75736C14.5858 6.10051 14.5858 9.89949 12.2426 12.2426C9.89948 14.5858 6.10049 14.5858 3.75736 12.2426C1.41421 9.89948 1.41421 6.10049 3.75736 3.75736C6.10051 1.41421 9.89949 1.41421 12.2426 3.75736"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SkipIcon;
